{% block jga_revocation_link_hint %}
    <div class="jga-revocation-link-hint">
        <p class="jga-revocation-link-hint__intro">
            {{ $tc('jga-revocation.linkHint.intro') }}
        </p>
        <div class="jga-revocation-link-hint__copy-row">
            <code class="jga-revocation-link-hint__url">{{ revocationUrl }}</code>
            <button
                type="button"
                class="jga-revocation-link-hint__copy-btn"
                :title="$tc('jga-revocation.linkHint.copy')"
                @click="copyUrl"
            >
                <sw-icon name="regular-copy" small></sw-icon>
                {{ $tc('jga-revocation.linkHint.copy') }}
            </button>
        </div>
        <p class="jga-revocation-link-hint__note">
            {{ $tc('jga-revocation.linkHint.note') }}
        </p>
    </div>
{% endblock %}
